export default __webpack_public_path__ + "static/media/66_photo.133e594f.jpg";